import SuccessIcon from "@/components/icons/success.svg"
import { Badge } from "@/components/ui/badge"
import { TokenIcon } from "@/components/token"
import { ReceiptBg } from "./receipt-bg"
import { Transaction } from "@/api/transactions"
import { shortenString } from "@/lib/utils"

interface PayReceiptProps {
  transaction: Transaction;
}

export default function PayReceipt({ transaction }: PayReceiptProps) {
  return (
    <div className="flex flex-col items-stretch max-w-96 w-full">
      <div className="bg-blue-500 rounded-sm h-3 outline-blue-100 outline-4 outline"></div>
      <div className="mx-4 relative">
        <div className="z-10 flex flex-col p-5 items-stretch gap-6 relative">
          <div className="flex justify-center">
            <img src={SuccessIcon} className="h-10 w-10" alt="Success" />
          </div>
          <div className="flex flex-col gap-1 items-center px-5">
            <h3 className="font-semibold text-2xl text-center">
              Payment was successful
            </h3>
            <p className="text-xs text-gray-300">We received your payment</p>
            <Badge
              variant="secondary"
              className="flex flex-row gap-2 p-1 pr-2 font-normal mt-1"
            >
              <TokenIcon name={transaction.token} size={20} />{" "}
              {transaction.amount} {transaction.token}
            </Badge>
          </div>
          <div className="flex flex-col bg-gray-50 rounded-xl p-4 text-sm flex-grow gap-2">
            <div className="flex flex-row gap-2 justify-between items-center">
              <div className="text-gray-300">Network</div>
              <div className="text-xs">{transaction.network}</div>
            </div>
            <div className="flex flex-row gap-2 justify-between items-center">
              <div className="text-gray-300">From</div>
              <div className="text-xs">
                {shortenString(transaction.fromAddress, 10)}
              </div>
            </div>
            <div className="flex flex-row gap-2 justify-between items-center">
              <div className="text-gray-300 whitespace-nowrap">
                Transaction ID
              </div>
              <div className="text-xs">
                {shortenString(transaction.hash, 10)}
              </div>
            </div>
          </div>
        </div>
        <div className="absolute h-full top-0 left-0 right-0 mx-auto -z-1 flex justify-center">
          <ReceiptBg width="100%" height="100%" />
        </div>
      </div>
    </div>
  )
}
